import styled, { css } from 'styled-components';
import { siteThemes, isGlobetrotter } from '../../utils/theming.js';

// @ts-nocheck
var GLOBETROTTER = siteThemes.GLOBETROTTER;
var textColor = function textColor(_ref) {
  var $messageType = _ref.$messageType,
    site = _ref.theme.site;
  var typesWithInvertedText = site === GLOBETROTTER ? ['info', 'travelInfo'] : ['error', 'success'];
  if (typesWithInvertedText.includes($messageType)) {
    return css(["var(--color-text-inverse)"]);
  }
  return css(["var(--color-text)"]);
};
var partnerColors = {
  ica: '#ed1c24',
  plussa: '#f6841f',
  loFavor: '#df1a22',
  coop: '#003366',
  aldreSagen: '#ab2026',
  veronmaksajat: '#0042D9'
};
var Message = styled.div.withConfig({
  displayName: "style__Message",
  componentId: "sc-14c9unw-0"
})(["width:100%;border-radius:var(--border-radius-500);box-shadow:var(--elevation-100);font:var(--font-body-m);color:", ";", " ", " ", ""], textColor, isGlobetrotter(css(["border-radius:0;box-shadow:none;"])), function (_ref2) {
  var $messageType = _ref2.$messageType;
  return $messageType && ($messageType === 'travelInfo' ? css(["background-color:var(--color-notif-system-info);"]) : css(["background-color:", ";"], "var(--color-notif-system-".concat($messageType, ")")));
}, function (_ref3) {
  var $partner = _ref3.$partner;
  return $partner && css(["background-color:var(--color-white);border-left:5px ", " solid;"], partnerColors[$partner]);
});
var MessageTop = styled.button.withConfig({
  displayName: "style__MessageTop",
  componentId: "sc-14c9unw-1"
})(["display:flex;width:100%;padding:var(--space-500);gap:var(--space-300);color:", ";", " ", " .sg-message-type-icon{flex-shrink:0;}", ""], textColor, function (_ref4) {
  var $expandable = _ref4.$expandable;
  return $expandable && css(["align-items:center;cursor:pointer;"]);
}, function (_ref5) {
  var $messageBodyDisplayType = _ref5.$messageBodyDisplayType;
  if ($messageBodyDisplayType === 'show-full' || $messageBodyDisplayType === 'show-ellipsis') {
    return css(["padding-bottom:var(--space-300);"]);
  }
  // shut up the linter
  return '';
}, function (_ref6) {
  var $partner = _ref6.$partner;
  return $partner && css(["gap:var(--space-400);"]);
});
var MessageBody = styled.div.withConfig({
  displayName: "style__MessageBody",
  componentId: "sc-14c9unw-2"
})(["display:none;flex-direction:column;gap:var(--space-100);padding:0 var(--space-600) var(--space-500) var(--space-500);", " .message__link{color:", ";}", ""], function (_ref7) {
  var $messageBodyDisplayType = _ref7.$messageBodyDisplayType;
  if ($messageBodyDisplayType === 'hidden') {
    return css(["display:none;"]);
  }
  if ($messageBodyDisplayType === 'show-ellipsis') return css(["display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;.message__link{display:none;}"]);
  return css(["display:flex;"]);
}, textColor, isGlobetrotter(css(["font:var(--font-body-s);"])));
var MessageTopContent = styled.div.withConfig({
  displayName: "style__MessageTopContent",
  componentId: "sc-14c9unw-3"
})(["display:flex;flex-direction:column;flex-grow:1;justify-content:center;"]);
var Header = styled.div.withConfig({
  displayName: "style__Header",
  componentId: "sc-14c9unw-4"
})(["width:100%;display:flex;align-items:flex-start;align-items:center;cursor:default;text-align:left;", " ", ""], function (_ref8) {
  var $expandable = _ref8.$expandable;
  return $expandable && css(["cursor:pointer;"]);
}, function (_ref9) {
  var $partner = _ref9.$partner;
  return $partner && css(["font-weight:normal;color:", ";"], partnerColors[$partner]);
});
var HeaderContent = styled.h4.withConfig({
  displayName: "style__HeaderContent",
  componentId: "sc-14c9unw-5"
})(["display:flex;flex-grow:1;font-size:inherit;font:var(--font-headline-xs);", ""], function (_ref10) {
  var $withSubtext = _ref10.$withSubtext,
    $expandable = _ref10.$expandable;
  return $withSubtext && !$expandable && css(["margin-bottom:var(--space-100);"]);
});

export { Header, HeaderContent, Message, MessageBody, MessageTop, MessageTopContent };
//# sourceMappingURL=style.js.map
